import React from "react";
import { Reveal } from "../shared/Reveal";

const SECTORS = [
  { label: "Retail & Supermarkets", img: "/brand/sector1.png" },
  { label: "Hospitality & Hotels", img: "/brand/sector2.png" },
  { label: "Manufacturing", img: "/brand/sector3.png" },
  { label: "Education & Schools", img: "/brand/sector4.png" },
  { label: "Airports & Transport", img: "/brand/sector5.png" },
  { label: "Forecourts & Convenience", img: "/brand/sector6.png" },
];

export default function Sectors() {
  return (
    <section id="sectors">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">EVERY SECTOR</Reveal>
        <Reveal className="h2" tag="div">Operational Intelligence for <span className="g">Every Estate.</span></Reveal>
        <div className="sectors">
          {SECTORS.map((s, i) => (
            <Reveal
              className="sector" tag="div" key={s.label} data-testid={`sector-${i}`}
              style={{ backgroundImage: `linear-gradient(180deg,rgba(11,21,51,.15),rgba(11,21,51,.85)),url('${s.img}')`, transitionDelay: `${(i % 3) * 0.07}s` }}
            >
              <span>{s.label}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
